import config from 'config';

import Fetch from 'tools/Fetch';

import {
    onUnauthorized,
} from 'entities/auth/functions';

import {
    ENTITY_PATH,
} from '../constants';
import {
    IGetAccountDraftsDto,
} from '../dto/get-account-drafts.dto';
import {
    IGetAccountDraftsResponse,
} from '../responses/get-account-drafts.response';

export function getAccountDraftsFetch(query: IGetAccountDraftsDto): Promise<IGetAccountDraftsResponse> {
    return new Fetch<IGetAccountDraftsResponse>({
        url: `${config.URL}${ENTITY_PATH}`,
        method: 'GET',
        query,
    })
        .on([200], (body) => {
            return body;
        })
        .on([401], (body) => {
            onUnauthorized();

            return body;
        })
        .on([400, 403, 500], (body) => {
            return body;
        })
        .exec();
}
